module.exports = __webpack_public_path__ + "img/illu-fire.2733660c.svg";